import { formatMoney } from '@shopify/theme-currency';
import { getTranslation } from '../helpers/utilities';
import { h } from 'preact';

import { useEffect, useState } from 'preact/hooks';

const CartItemPrice = ({ item }) => {
  const [price, setPrice] = useState(item.line_price);
  const [comparePrice, setComparePrice] = useState(null);

  useEffect(() => {
    setPrice(item.line_price);
    setComparePrice(item.compare_at_price * item.quantity);
  }, [item]);

  return !!item.compare_at_price && item.compare_at_price > item.price ? (
    <div class="flex flex-col space-x-3 md:block md:space-x-0 md:space-y-0.5">
      <div class="md:type-body-1 type-nav-item text-right text-tidal-wave">
        <span class="sr-only">{getTranslation('cart.discounted_price')}</span>
        <span class="block">{formatMoney(price, theme.moneyFormat)}</span>
      </div>
      <div class="md:type-body-1 type-nav-item text-right text-stone">
        <span class="sr-only">{getTranslation('cart.original_price')}</span>
        <span class="block line-through">
          {formatMoney(comparePrice, theme.moneyFormat)}
        </span>
      </div>
    </div>
  ) : (
    <div class="type-body-1 text-right">
      {formatMoney(price, theme.moneyFormat)}
    </div>
  );
};

export default CartItemPrice;
